import { Box } from "@mui/material";
import { FC, useRef, useState } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { useLocalization } from "../../hooks/useLocalization";
import { MinSessionDurationDialog } from "./MinSessionDurationDialog";
import { MinSessionDurationMenu } from "./MinSessionDurationMenu";
import { MinSessionDurationTrigger } from "./MinSessionDurationTrigger";
import { clampDuration, toDraft, toNumberOrNull } from "./utils";

export interface MinSessionDurationFilterProps {
  value: number | null;
  onChange: (minutes: number | null) => void;
  label?: string;
}

export const MinSessionDurationFilter: FC<MinSessionDurationFilterProps> = ({
  value,
  onChange,
  label,
}) => {
  const { t } = useLocalization();
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);
  const [draft, setDraft] = useState<string>("");
  const buttonWrapperRef = useRef<HTMLDivElement>(null);

  const labelText = label ?? t("components.minSessionDurationFilter.label");

  const handleClick = () => {
    setDraft(toDraft(value));
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleApply = () => {
    const parsed = toNumberOrNull(draft);

    onChange(parsed === null ? null : clampDuration(parsed));
    setIsOpen(false);
  };

  const handleCancel = () => {
    setDraft(toDraft(value));
    setIsOpen(false);
  };

  return (
    <>
      <Box ref={buttonWrapperRef} sx={{ display: "inline-flex" }}>
        <MinSessionDurationTrigger
          label={labelText}
          onClick={handleClick}
          value={value}
        />
      </Box>
      {isMobile ? (
        <MinSessionDurationDialog
          draft={draft}
          handleApply={handleApply}
          handleCancel={handleCancel}
          isModalOpen={isOpen}
          label={labelText}
          onDraftChange={setDraft}
        />
      ) : (
        <MinSessionDurationMenu
          anchorEl={buttonWrapperRef.current}
          draft={draft}
          handleApply={handleApply}
          handleCancel={handleCancel}
          handleClose={handleClose}
          onDraftChange={setDraft}
          open={isOpen}
        />
      )}
    </>
  );
};
